// Vue
import { Component, Prop, Vue } from "vue-property-decorator";
// Template
import { Headline } from "#/components/headline/Headline";
import template from "./template.vue";

type HeadlineType = "h1" | "h2" | "h3" | "subline" | "big" | "small";
type ColorType = "black" | "white";

@Component({
  mixins: [template],
  components: {
    Headline,
  },
})
export class AufbauplusHeadline extends Vue {
  @Prop({ default: "h1" })
  public type!: HeadlineType;

  @Prop({ default: "" })
  public weight!: string;

  @Prop({ default: "black" })
  public backgroundColor!: ColorType;

  @Prop({ default: false })
  public disableLine!: boolean;

  get isMgsHeadline() {
    return (
      this.type == "h1" ||
      this.type == "h2" ||
      this.type == "h3" ||
      this.type == "subline"
    );
  }

  get headlineTheme() {
    return this.backgroundColor == "white" ? "default" : "secondary";
  }

  get mgsHeadlineSize() {
    switch (this.type) {
      case "h1":
        return 1;
      case "h2":
        return 2;
      case "h3":
        return 3;
      case "subline":
        return 4;
      default:
        return 1;
    }
  }

  get hasMgsLine() {
    if (this.disableLine) {
      return false;
    } else {
      return this.type == "h2";
    }
  }

  get mgsHeadlineClasses() {
    let result: Array<string> = [];

    switch (this.type) {
      case "h1":
        result.push("mar-bottom-xxl");
        break;
      case "h2":
        result.push("mar-bottom-lg");
        break;
      case "h3":
        result.push("mar-bottom-sm");
        break;
      case "subline":
        result.push("mar-bottom-sm");
        break;
    }

    if (this.hasMgsLine) {
      result.push("mar-top-xxl");
    }

    return result;
  }

  get aufbauplusHeadlineClasses() {
    let result: Array<string> = [
      `${this.$appPrefix}-aufbauplus-h`,
      `${this.$appPrefix}-aufbauplus-h--${this.headlineTheme}`,
    ];

    if (this.type == "big") {
      if (!this.disableLine) {
        result.push(`${this.$appPrefix}-aufbauplus-h--line`);
      }
      result.push("mar-top-xxl");
      result.push("mar-bottom-xxl");
    }

    if (this.type == "small") {
      result.push("mar-bottom-lg");
    }

    return result;
  }

  get aufbauplusHComponent() {
    switch (this.type) {
      case "big":
        return "h1";
      case "small":
        return "h2";
    }
  }

  get aufbauplusHeadingClass() {
    if (this.type == "big") {
      return `wb-e-hdl-1`;
    } else {
      return `wb-e-hdl-3`;
    }
  }
}
